import { Box } from '@mui/material';
import ManageWebApi from 'api/application/manageWeb';
import { AboutUsProps } from 'api/application/manageWeb-interface';
import BtnDelFilled from 'assets/button/BtnDelFilled';
import BtnEdit from 'assets/button/BtnEdit';
import ButtonCustom from 'component/Button/ButtonCustom';
import { notiError, notiSuccess } from 'component/notifications/notifications';
import { colors } from 'constants/theme';
import { ContentState, EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import AlertModal from 'new-components/modal/alert-modal';
import SnackbarComponent from 'new-components/snackbar/snackbar-component';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ManageWebEditor } from '../manage-web';
import { ContainerEditor } from '../useStyles';

const AboutUs = () => {
    const { t } = useTranslation()
    const t_ABOUT_US = "MANAGE_WEB.ABOUT_US"

    const [load, setLoad] = useState<boolean>(true)

    const [editorState, setEditorState] = useState<any>(EditorState.createEmpty())
    const [contentWeb, setContentWeb] = useState<any>({})
    const [isEdit, setIsEdit] = useState<boolean>(false)

    const [contentLength, setContentLength] = useState<number>(0)
    const [errorMaxLength, setErrorMaxLength] = useState<boolean>(false)

    const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
    const [isOpenSnack, setIsOpenSnack] = useState(false)
    const [typeSnack, setTypeSnack] = useState<any>("success")
    const [labelSnack, setLabelSnack] = useState('')

    const loadData = async () => {
        setLoad(true)
        await ManageWebApi.getAboutUs().then((res) => {
            setContentWeb(res?.data || {})
        }).catch(() => {
            return
        }).finally(() => {
            setLoad(false)
        })
    }

    useEffect(() => {
        loadData()
    }, [])

    const onEdit = (status: boolean) => {
        setIsEdit(status)
        if (status && contentWeb?.content) {
            const newHTML: any = contentWeb?.content
            const blocksFromHTML = htmlToDraft(newHTML);
            const content = ContentState.createFromBlockArray(
                blocksFromHTML.contentBlocks,
                blocksFromHTML.entityMap,
            );
            setEditorState(EditorState.createWithContent(content))
            const currentContent = EditorState.createWithContent(content)?.getCurrentContent();
            const currentContentLength = currentContent.getPlainText('')?.length;
            if (currentContentLength > 1000) {
                setErrorMaxLength(true)
            }
        }
        else {
            setEditorState(EditorState.createEmpty())
        }
    }

    const onDel = async () => {
        ManageWebApi.delAboutUs(contentWeb.aboutUsMinimalId).then((resp) => {
            if (resp === "pass") {
                setIsOpenAlertModal(false)
                setIsOpenSnack(true)
                setTypeSnack("success")
                setLabelSnack(t(`${t_ABOUT_US}.DEL_SUC`))
                loadData()
            } else {
                setIsOpenAlertModal(false)
                setIsOpenSnack(true)
                setTypeSnack("error")
                setLabelSnack(t(`${t_ABOUT_US}.SAVE_ERROR`))
            }
        })
    }

    const onSave = async () => {
        const newPayload: AboutUsProps = {
            content: draftToHtml(convertToRaw(editorState?.getCurrentContent())) || ''
        }
        if (contentWeb?.aboutUsMinimalId) {
            newPayload.aboutUsMinimalId = contentWeb.aboutUsMinimalId
        }

        const res = await ManageWebApi.saveAboutUs(newPayload)
        if (res === "pass") {
            onEdit(false)
            loadData()
            notiSuccess(t(`${t_ABOUT_US}.SAVE_SUC`))
        } else {
            notiError(t(`${t_ABOUT_US}.SAVE_ERROR`))
        }

    }

    const handleEditor = (editorState: EditorState) => {
        const currentContent = editorState.getCurrentContent();
        const currentContentLength = currentContent.getPlainText('').length;

        if (currentContentLength > 1000) {
            setErrorMaxLength(true)
        } else {
            setEditorState(editorState)
            setContentLength(currentContentLength)
            setErrorMaxLength(false)
        }
    }

    return (
        <>
            <AlertModal
                isOpen={isOpenAlertModal}
                title={t(`MANAGE_WEB.TITLE_DEL`)}
                message={t('MANAGE_WEB.ABOUT_US.NOTI_DEL')}
                type="error"
                handleClose={() => setIsOpenAlertModal(false)}
                onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
                onSubmit={{ onClick: onDel, title: t('BUTTON.SUBMIT') }}
            />
            <SnackbarComponent
                onOpen={isOpenSnack}
                onClose={() => setIsOpenSnack(false)}
                label={labelSnack}
                type={typeSnack}
                transform={`translateX(calc(95vw - 100% - 32px))`}
                autoHideTime={3000}
            />
            {!load &&
                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Box sx={{ fontSize: '20px', fontWeight: "600" }}>
                            {t(`${t_ABOUT_US}.TITLE`)}
                        </Box>
                        {!contentWeb?.content && !isEdit &&
                            <Box>
                                <ButtonCustom
                                    textButton={t(`${t_ABOUT_US}.BTN_CREATE`)}
                                    onClick={() => { onEdit(true) }}
                                />
                            </Box>
                            || !isEdit &&
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <ButtonCustom
                                    startIcon={<BtnEdit />}
                                    style={{ marginRight: '4px' }}
                                    variant={'outlined'}
                                    textButton={t(`${t_ABOUT_US}.BTN_EDIT`)}
                                    onClick={() => { onEdit(true) }}
                                />
                                <ButtonCustom
                                    startIcon={<BtnDelFilled color='#fff' />}
                                    mode={'del'}
                                    textButton={t(`${t_ABOUT_US}.BTN_DEL`)}
                                    onClick={() => { setIsOpenAlertModal(true) }}
                                />
                            </Box>
                            ||
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <ButtonCustom
                                    style={{ marginRight: '4px' }}
                                    variant={'outlined'}
                                    textButton={t(`${t_ABOUT_US}.BTN_CANCEL`)}
                                    onClick={() => { onEdit(false) }}
                                />
                                <ButtonCustom
                                    disabled={errorMaxLength}
                                    textButton={t(`${t_ABOUT_US}.BTN_SAVE`)}
                                    onClick={() => { onSave() }}
                                />
                            </Box>
                        }
                    </Box>


                    {!isEdit &&
                        <Box sx={{ marginTop: '32px', height: '100%', overflow: 'auto' }}>
                            <div dangerouslySetInnerHTML={{ __html: contentWeb?.content }} />
                        </Box>
                        ||
                        <ContainerEditor>
                            <Box
                                sx={{
                                    color: errorMaxLength ? colors.statusInactive : 'black',
                                    height: '24px',
                                    padding: '0px 0px 0px 16px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}
                            >
                                <Box>
                                    {errorMaxLength && t(`${t_ABOUT_US}.MAX_LENGTH`)}
                                </Box>
                                <Box>
                                    {`${contentLength}/1000`}
                                </Box>
                            </Box>
                            <ManageWebEditor
                                editorState={editorState}
                                setEditorState={handleEditor}
                            />
                        </ContainerEditor>
                    }
                </Box>
            }

        </>
    )
}

export default AboutUs